import { cn } from '@/shared/lib/utils'

export type AvatarCompositeSize = 'xs' | 'sm' | 'md' | 'lg'

const shellBySize: Record<AvatarCompositeSize, string> = {
  xs: 'size-9',
  sm: 'size-11',
  md: 'h-[76px] w-[76px]  sm:h-[84px] sm:w-[84px]',
  lg: 'mx-auto aspect-square w-full max-w-[240px]'
}

const avatarInsetBySize: Record<AvatarCompositeSize, string> = {
  xs: 'inset-[2px]',
  sm: 'inset-[3px]',
  md: 'inset-[5%]',
  lg: 'inset-[4%]'
}

const innerClipBySize: Record<AvatarCompositeSize, string> = {
  xs: 'rounded-lg',
  sm: 'rounded-xl',
  md: 'rounded-xl',
  lg: 'rounded-2xl'
}

export function AvatarComposite({
  backgroundUrl,
  avatarUrl,
  frameUrl,
  size = 'md',
  className,
  'aria-label': ariaLabel
}: {
  backgroundUrl: string | null
  avatarUrl: string
  frameUrl: string | null
  size?: AvatarCompositeSize
  className?: string
  'aria-label'?: string
}) {
  return (
    <div
      className={cn(
        'relative aspect-square shrink-0',
        shellBySize[size],
        className
      )}
      aria-label={ariaLabel}
    >
      <div
        className={cn(
          'absolute inset-0 bg-cover bg-center transition-opacity duration-300',
          !backgroundUrl && 'bg-transparent'
        )}
        style={
          backgroundUrl
            ? { backgroundImage: `url(${backgroundUrl})` }
            : undefined
        }
      />
      <div
        className={cn(
          'absolute overflow-hidden',
          innerClipBySize[size],
          avatarInsetBySize[size]
        )}
      >
        <img
          src={avatarUrl}
          alt=""
          className="size-full object-cover"
          width={256}
          height={256}
          draggable={false}
        />
      </div>
      {frameUrl ? (
        <img
          src={frameUrl}
          alt=""
          className="pointer-events-none absolute inset-0 size-full object-cover select-none"
          width={512}
          height={512}
          draggable={false}
        />
      ) : null}
    </div>
  )
}
